import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 7 4'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M6.82 1.146 4.172 3.813A.73.73 0 0 1 3.694 4a.66.66 0 0 1-.479-.187L.569 1.146a.645.645 0 0 1-.166-.73A.68.68 0 0 1 1.028 0H6.34c.27 0 .5.167.604.417a.67.67 0 0 1-.125.729'
    />
  </svg>
)
export default SvgComponent
